module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-Difficulty-Star-16ef67d36392f0e7c6d2086cb9d4f272.png";